import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { delay2673xnmlkmidc as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  StartOperation372o3p2p9vxt5 as StartOperation,
  GeneralError1q7afgn844yvi as GeneralError,
  NetworkErrorotwtrw4n54or as NetworkError,
  ConnectionReEstablishedspo1kq7uvs59 as ConnectionReEstablished,
  OperationComplete35pb9wj3i5rr0 as OperationComplete,
  OperationError2sah6hjojh8as as OperationError,
  OperationResponseq42n5mfh87yx as OperationResponse,
  StopOperation41dlmx7s82zc as StopOperation,
  Dispose3n637sa8gbmf1 as Dispose,
  RestartConnection3ucejekzrnll6 as RestartConnection,
  Command2ao3eytvqoynn as Command,
  RestartConnection_instancely4s5aq31fta as RestartConnection_instance,
  Event2qcujbxqrid4f as Event,
  Dispose_instance2o1vl3dhvm8a9 as Dispose_instance,
} from './internal/WsMessage.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance30q5r2nw695ls as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  isDeferred3jq83655znees as isDeferred,
  DeferredJsonMerger16i62uujz1qml as DeferredJsonMerger,
} from '../../internal/DeferredJsonMerger.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CoroutineStart_UNDISPATCHED_getInstanceldihd7d5m0an as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { add2suhfggl4zvkk as add } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { DefaultWebSocketEngine2qlkcxmcddkl7 as DefaultWebSocketEngine } from './JsWebSocketEngine.mjs';
import { Factory2jyzsj2j7cj0z as Factory } from './SubscriptionWsProtocol.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { BufferOverflow_SUSPEND_getInstance31wn3v83onf3w as BufferOverflow_SUSPEND_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import { MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/SharedFlow.mjs';
import {
  asSharedFlow2buz3fbrowsyg as asSharedFlow,
  onSubscription3iwvbdmbwg7iq as onSubscription,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Share.mjs';
import { Dispatchers_getInstancewbokwrm9sosb as Dispatchers_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { transformWhile1eyv77fe96rjt as transformWhile } from '../../internal/flows.mjs';
import { onCompletion2zzj1m13j2omp as onCompletion } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Emitters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WebSocketNetworkTransport$Builder$serverUrl$slambdaClass;
function WebSocketNetworkTransport$Builder$serverUrl$slambda() {
  if (WebSocketNetworkTransport$Builder$serverUrl$slambdaClass === VOID) {
    class $ {
      constructor($serverUrl) {
        this.l6a_1 = $serverUrl;
      }
      td($completion) {
        return this.l6a_1;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    WebSocketNetworkTransport$Builder$serverUrl$slambdaClass = $;
  }
  return WebSocketNetworkTransport$Builder$serverUrl$slambdaClass;
}
function WebSocketNetworkTransport$Builder$serverUrl$slambda_0($serverUrl) {
  var i = new (WebSocketNetworkTransport$Builder$serverUrl$slambda())($serverUrl);
  var l = ($completion) => i.td($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = supervise($this.m6a_1, $this$launch, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = ensureNotNull($this.n6a_1._v).k6a($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = delay($this.b6b_1.r6a_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  supervise$closeProtocol($this.c6b_1, $this.d6b_1, $this.e6b_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$onSubscription, $completion) {
  var tmp = $this.f6b_1.u6a_1.e1b(new (StartOperation())($this.g6b_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, value, $completion) {
  var tmp0 = $this.h6b_1;
  $l$block: {
    if (value.v31() === $this.i6b_1.e43_1.toString() || value.v31() == null) {
      var tmp = tmp0.s1d(value, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      break $l$block;
    }
  }
  return Unit_instance;
}
function *_generator_collect__dlomyy($this, collector, $completion) {
  var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_0(collector, $this.k6b_1);
  var tmp_0 = $this.j6b_1.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var WebSocketNetworkTransport$execute$o$collect$slambdaClass;
function WebSocketNetworkTransport$execute$o$collect$slambda() {
  if (WebSocketNetworkTransport$execute$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $request) {
        this.h6b_1 = $$this$unsafeFlow;
        this.i6b_1 = $request;
      }
      b1i(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, value), $completion);
      }
      ud(p1, $completion) {
        return this.b1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$o$collect$slambdaClass = $;
  }
  return WebSocketNetworkTransport$execute$o$collect$slambdaClass;
}
function WebSocketNetworkTransport$execute$o$collect$slambda_0($$this$unsafeFlow, $request) {
  var i = new (WebSocketNetworkTransport$execute$o$collect$slambda())($$this$unsafeFlow, $request);
  var l = (value, $completion) => i.b1i(value, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $this$transformWhile, it, $completion) {
  var tmp;
  if (it instanceof OperationComplete()) {
    tmp = false;
  } else {
    if (it instanceof ConnectionReEstablished()) {
      tmp = false;
    } else {
      if (it instanceof NetworkError()) {
        var tmp_0 = $this$transformWhile.s1d(it, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = false;
      } else {
        if (it instanceof GeneralError()) {
          println('Received general error while executing operation ' + $this.l6b_1.d43_1.operationName() + ': ' + toString(it.m6b_1));
          tmp = true;
        } else {
          var tmp_1 = $this$transformWhile.s1d(it, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          tmp = true;
        }
      }
    }
  }
  return tmp;
}
function *_generator_invoke__zhh2q8_5($this, value, $completion) {
  var $this$transform = $this.o6b_1;
  var tmp;
  if (value instanceof OperationResponse()) {
    var responsePayload = value.x6b_1;
    var requestCustomScalarAdapters = ensureNotNull($this.p6b_1.f43_1.m46(Key_getInstance()));
    var tmp_0;
    if (isDeferred(responsePayload)) {
      tmp_0 = to($this.q6b_1.g66(responsePayload), $this.q6b_1.c66_1);
    } else {
      tmp_0 = to(responsePayload, null);
    }
    var _destruct__k2r9zo = tmp_0;
    var payload = _destruct__k2r9zo.df();
    var mergedFragmentIds = _destruct__k2r9zo.ef();
    var apolloResponse = toApolloResponse(jsonReader(payload), $this.p6b_1.d43_1, $this.p6b_1.e43_1, requestCustomScalarAdapters, mergedFragmentIds);
    if (!$this.q6b_1.d66_1) {
      $this.q6b_1.n3o();
    }
    tmp = apolloResponse;
  } else {
    if (value instanceof OperationError()) {
      tmp = errorResponse($this.r6b_1, $this.p6b_1, SubscriptionOperationException().x4d($this.p6b_1.d43_1.operationName(), value.v6b_1));
    } else {
      if (value instanceof NetworkError()) {
        tmp = errorResponse($this.r6b_1, $this.p6b_1, ApolloNetworkException().o47('Network error while executing ' + $this.p6b_1.d43_1.operationName(), value.s6b_1));
      } else {
        var tmp_1;
        if (value instanceof ConnectionReEstablished()) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (value instanceof OperationComplete()) {
            tmp_2 = true;
          } else {
            tmp_2 = value instanceof GeneralError();
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          var message = 'Unexpected event ' + toString_0(value);
          throw IllegalStateException().o(toString_0(message));
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  var tmp$ret$0 = tmp;
  var tmp_3 = $this$transform.s1d(tmp$ret$0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function *_generator_collect__dlomyy_0($this, collector, $completion) {
  var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_2(collector, $this.z6b_1, $this.a6c_1, $this.b6c_1);
  var tmp_0 = $this.y6b_1.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var WebSocketNetworkTransport$execute$o$collect$slambdaClass_0;
function WebSocketNetworkTransport$execute$o$collect$slambda_1() {
  if (WebSocketNetworkTransport$execute$o$collect$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $request, $deferredJsonMerger, this$0) {
        this.o6b_1 = $$this$unsafeFlow;
        this.p6b_1 = $request;
        this.q6b_1 = $deferredJsonMerger;
        this.r6b_1 = this$0;
      }
      b1i(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, value), $completion);
      }
      ud(p1, $completion) {
        return this.b1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$o$collect$slambdaClass_0 = $;
  }
  return WebSocketNetworkTransport$execute$o$collect$slambdaClass_0;
}
function WebSocketNetworkTransport$execute$o$collect$slambda_2($$this$unsafeFlow, $request, $deferredJsonMerger, this$0) {
  var i = new (WebSocketNetworkTransport$execute$o$collect$slambda_1())($$this$unsafeFlow, $request, $deferredJsonMerger, this$0);
  var l = (value, $completion) => i.b1i(value, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, value, $completion) {
  var tmp0 = $this.c6c_1;
  $l$block: {
    if (!$this.d6c_1.e66_1) {
      var tmp = tmp0.s1d(value, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      break $l$block;
    }
  }
  return Unit_instance;
}
function *_generator_collect__dlomyy_1($this, collector, $completion) {
  var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_4(collector, $this.f6c_1);
  var tmp_0 = $this.e6c_1.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var WebSocketNetworkTransport$execute$o$collect$slambdaClass_1;
function WebSocketNetworkTransport$execute$o$collect$slambda_3() {
  if (WebSocketNetworkTransport$execute$o$collect$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $deferredJsonMerger) {
        this.c6c_1 = $$this$unsafeFlow;
        this.d6c_1 = $deferredJsonMerger;
      }
      b1i(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, value), $completion);
      }
      ud(p1, $completion) {
        return this.b1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$o$collect$slambdaClass_1 = $;
  }
  return WebSocketNetworkTransport$execute$o$collect$slambdaClass_1;
}
function WebSocketNetworkTransport$execute$o$collect$slambda_4($$this$unsafeFlow, $deferredJsonMerger) {
  var i = new (WebSocketNetworkTransport$execute$o$collect$slambda_3())($$this$unsafeFlow, $deferredJsonMerger);
  var l = (value, $completion) => i.b1i(value, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, $this$onCompletion, it, $completion) {
  var tmp = $this.g6c_1.u6a_1.e1b(new (StopOperation())($this.h6c_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_supervise__2w8vw4($this, scope, $completion) {
  var idleJob = {_v: null};
  var connectionJob = {_v: null};
  var protocol = {_v: null};
  var reopenAttemptCount = 0n;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var activeMessages = LinkedHashMap().gc();
  $l$loop_1: while (true) {
    var tmp = $this.u6a_1.i1b($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var message = tmp;
    if (isInterface(message, Event())) {
      if (message instanceof NetworkError()) {
        supervise$closeProtocol(protocol, connectionJob, idleJob);
        var tmp0_safe_receiver = $this.t6a_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          var tmp_1 = tmp0_safe_receiver(message.s6b_1, reopenAttemptCount, $completion);
          if (tmp_1 === get_COROUTINE_SUSPENDED())
            tmp_1 = yield tmp_1;
          tmp_0 = tmp_1;
        }
        if (tmp_0 === true) {
          var _unary__edvuaz = reopenAttemptCount;
          reopenAttemptCount = add(_unary__edvuaz, get_ONE());
          var tmp_2 = $this.u6a_1.e1b(RestartConnection_instance, $completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
        } else {
          reopenAttemptCount = 0n;
          $this.v6a_1.u1e(message);
        }
      } else {
        if (message instanceof ConnectionReEstablished()) {
          reopenAttemptCount = 0n;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = activeMessages.b5().u1();
          while (_iterator__ex2g4s.v1()) {
            var element = _iterator__ex2g4s.w1();
            $this.u6a_1.f1b(element);
          }
        } else {
          reopenAttemptCount = 0n;
          $this.v6a_1.u1e(message);
        }
      }
    } else {
      if (isInterface(message, Command())) {
        if (message instanceof Dispose()) {
          supervise$closeProtocol(protocol, connectionJob, idleJob);
          return Unit_instance;
        }
        if (protocol._v == null) {
          if (message instanceof StopOperation()) {
            activeMessages.d5(message.i6c_1.e43_1);
            continue $l$loop_1;
          }
          var tmp_3;
          try {
            var tmp_4 = $this.o6a_1($completion);
            if (tmp_4 === get_COROUTINE_SUSPENDED())
              tmp_4 = yield tmp_4;
            var tmp_5;
            var tmp0 = $this.p6a_1;
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_6;
              if (isInterface(tmp0, Collection())) {
                tmp_6 = tmp0.s1();
              } else {
                tmp_6 = false;
              }
              if (tmp_6) {
                tmp$ret$3 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s_0 = tmp0.u1();
              while (_iterator__ex2g4s_0.v1()) {
                var element_0 = _iterator__ex2g4s_0.w1();
                if (element_0.d49_1 === 'Sec-WebSocket-Protocol') {
                  tmp$ret$3 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$3 = false;
            }
            if (tmp$ret$3) {
              tmp_5 = $this.p6a_1;
            } else {
              tmp_5 = plus($this.p6a_1, new (HttpHeader())('Sec-WebSocket-Protocol', $this.s6a_1.m1()));
            }
            var tmp_7 = $this.q6a_1.j6c(tmp_4, tmp_5, $completion);
            if (tmp_7 === get_COROUTINE_SUSPENDED())
              tmp_7 = yield tmp_7;
            tmp_3 = tmp_7;
          } catch ($p) {
            var tmp_8;
            if ($p instanceof Exception()) {
              var e = $p;
              var tmp_9 = $this.u6a_1.e1b(new (NetworkError())(e), $completion);
              if (tmp_9 === get_COROUTINE_SUSPENDED())
                tmp_9 = yield tmp_9;
              continue $l$loop_1;
            } else {
              throw $p;
            }
          }
          var webSocketConnection = tmp_3;
          protocol._v = $this.s6a_1.w69(webSocketConnection, $this.a6b_1, scope);
          try {
            var tmp_10 = ensureNotNull(protocol._v).x69($completion);
            if (tmp_10 === get_COROUTINE_SUSPENDED())
              tmp_10 = yield tmp_10;
          } catch ($p) {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              protocol._v = null;
              var tmp_11 = $this.u6a_1.e1b(new (NetworkError())(e_0), $completion);
              if (tmp_11 === get_COROUTINE_SUSPENDED())
                tmp_11 = yield tmp_11;
              continue $l$loop_1;
            } else {
              throw $p;
            }
          }
          var tmp_12 = CoroutineStart_UNDISPATCHED_getInstance();
          connectionJob._v = launch(scope, VOID, tmp_12, WebSocketNetworkTransport$supervise$slambda_0(protocol));
        }
        if (message instanceof StartOperation()) {
          // Inline function 'kotlin.collections.set' call
          var key = message.k6c_1.e43_1;
          activeMessages.c5(key, message);
          ensureNotNull(protocol._v).d6a(message.k6c_1);
        } else {
          if (message instanceof StopOperation()) {
            activeMessages.d5(message.i6c_1.e43_1);
            ensureNotNull(protocol._v).e6a(message.i6c_1);
          } else {
            if (message instanceof RestartConnection()) {
              var tmp_13 = $this.u6a_1.e1b(new (ConnectionReEstablished())(), $completion);
              if (tmp_13 === get_COROUTINE_SUSPENDED())
                tmp_13 = yield tmp_13;
            }
          }
        }
        if (activeMessages.s1()) {
          idleJob._v = launch(scope, VOID, VOID, WebSocketNetworkTransport$supervise$slambda_2($this, protocol, connectionJob, idleJob));
        } else {
          var tmp2_safe_receiver = idleJob._v;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.px();
          }
          idleJob._v = null;
        }
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function supervise($this, scope, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_supervise__2w8vw4.bind(VOID, $this, scope), $completion);
}
function errorResponse($this, request, apolloException) {
  var tmp0_requestUuid = request.e43_1;
  var tmp1_operation = request.d43_1;
  return Builder().b44(tmp1_operation, tmp0_requestUuid).g44(apolloException).i44(true).n37();
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.q64_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.r64_1 = ArrayList().u2();
        this.s64_1 = null;
        this.t64_1 = null;
        this.u64_1 = null;
        this.v64_1 = null;
      }
      p63(serverUrl) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        tmp.q64_1 = WebSocketNetworkTransport$Builder$serverUrl$slambda_0(serverUrl);
        return this;
      }
      a65(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.q64_1 = serverUrl;
        return this;
      }
      w64(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.s64_1 = webSocketEngine;
        return this;
      }
      x64(idleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.t64_1 = idleTimeoutMillis;
        return this;
      }
      y64(protocolFactory) {
        // Inline function 'kotlin.apply' call
        this.u64_1 = protocolFactory;
        return this;
      }
      z64(reopenWhen) {
        // Inline function 'kotlin.apply' call
        this.v64_1 = reopenWhen;
        return this;
      }
      n37() {
        var tmp0_elvis_lhs = this.q64_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var message = 'No serverUrl specified';
          throw IllegalStateException().o(toString_0(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp_1 = this.r64_1;
        var tmp1_elvis_lhs = this.s64_1;
        var tmp_2 = tmp1_elvis_lhs == null ? new (DefaultWebSocketEngine())() : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.t64_1;
        var tmp_3 = tmp2_elvis_lhs == null ? 60000n : tmp2_elvis_lhs;
        var tmp3_elvis_lhs = this.u64_1;
        return new (WebSocketNetworkTransport())(tmp_0, tmp_1, tmp_2, tmp_3, tmp3_elvis_lhs == null ? new (Factory())() : tmp3_elvis_lhs, this.v64_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.l6c_1 = function_0;
      }
      s1d(value, $completion) {
        return this.l6c_1(value, $completion);
      }
      n5() {
        return this.l6c_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.n5(), other.n5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.n5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var WebSocketNetworkTransport$slambdaClass;
function WebSocketNetworkTransport$slambda() {
  if (WebSocketNetworkTransport$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.m6a_1 = this$0;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$slambdaClass = $;
  }
  return WebSocketNetworkTransport$slambdaClass;
}
function WebSocketNetworkTransport$slambda_0(this$0) {
  var i = new (WebSocketNetworkTransport$slambda())(this$0);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$listener$1Class;
function WebSocketNetworkTransport$listener$1() {
  if (WebSocketNetworkTransport$listener$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.m6c_1 = this$0;
      }
      c6a(id, payload) {
        this.m6c_1.u6a_1.f1b(new (OperationResponse())(id, payload));
      }
      b6a(id, payload) {
        this.m6c_1.u6a_1.f1b(new (OperationError())(id, payload));
      }
      z69(id) {
        this.m6c_1.u6a_1.f1b(new (OperationComplete())(id));
      }
      a6a(payload) {
        this.m6c_1.u6a_1.f1b(new (GeneralError())(payload));
      }
      n6c(cause) {
        this.m6c_1.u6a_1.f1b(new (NetworkError())(cause));
      }
    }
    initMetadataForClass($);
    WebSocketNetworkTransport$listener$1Class = $;
  }
  return WebSocketNetworkTransport$listener$1Class;
}
function supervise$closeProtocol(protocol, connectionJob, idleJob) {
  var tmp0_safe_receiver = protocol._v;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.q6();
  }
  protocol._v = null;
  var tmp1_safe_receiver = connectionJob._v;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.px();
  }
  connectionJob._v = null;
  var tmp2_safe_receiver = idleJob._v;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.px();
  }
  idleJob._v = null;
}
var WebSocketNetworkTransport$supervise$slambdaClass;
function WebSocketNetworkTransport$supervise$slambda() {
  if (WebSocketNetworkTransport$supervise$slambdaClass === VOID) {
    class $ {
      constructor($protocol) {
        this.n6a_1 = $protocol;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$supervise$slambdaClass = $;
  }
  return WebSocketNetworkTransport$supervise$slambdaClass;
}
function WebSocketNetworkTransport$supervise$slambda_0($protocol) {
  var i = new (WebSocketNetworkTransport$supervise$slambda())($protocol);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$supervise$slambdaClass_0;
function WebSocketNetworkTransport$supervise$slambda_1() {
  if (WebSocketNetworkTransport$supervise$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $protocol, $connectionJob, $idleJob) {
        this.b6b_1 = this$0;
        this.c6b_1 = $protocol;
        this.d6b_1 = $connectionJob;
        this.e6b_1 = $idleJob;
      }
      c1g($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      ud(p1, $completion) {
        return this.c1g((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$supervise$slambdaClass_0 = $;
  }
  return WebSocketNetworkTransport$supervise$slambdaClass_0;
}
function WebSocketNetworkTransport$supervise$slambda_2(this$0, $protocol, $connectionJob, $idleJob) {
  var i = new (WebSocketNetworkTransport$supervise$slambda_1())(this$0, $protocol, $connectionJob, $idleJob);
  var l = ($this$launch, $completion) => i.c1g($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$execute$slambdaClass;
function WebSocketNetworkTransport$execute$slambda() {
  if (WebSocketNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $request) {
        this.f6b_1 = this$0;
        this.g6b_1 = $request;
      }
      o6c($this$onSubscription, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$onSubscription), $completion);
      }
      ud(p1, $completion) {
        return this.o6c((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$slambdaClass = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass;
}
function WebSocketNetworkTransport$execute$slambda_0(this$0, $request) {
  var i = new (WebSocketNetworkTransport$execute$slambda())(this$0, $request);
  var l = ($this$onSubscription, $completion) => i.o6c($this$onSubscription, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$execute$$inlined$filter$1Class;
function WebSocketNetworkTransport$execute$$inlined$filter$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filter$1Class === VOID) {
    class $ {
      constructor($this, $request) {
        this.j6b_1 = $this;
        this.k6b_1 = $request;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filter$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filter$1Class;
}
var WebSocketNetworkTransport$execute$slambdaClass_0;
function WebSocketNetworkTransport$execute$slambda_1() {
  if (WebSocketNetworkTransport$execute$slambdaClass_0 === VOID) {
    class $ {
      constructor($request) {
        this.l6b_1 = $request;
      }
      p6c($this$transformWhile, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$transformWhile, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.p6c(tmp, (!(p2 == null) ? isInterface(p2, Event()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WebSocketNetworkTransport$execute$slambdaClass_0 = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass_0;
}
function WebSocketNetworkTransport$execute$slambda_2($request) {
  var i = new (WebSocketNetworkTransport$execute$slambda_1())($request);
  var l = ($this$transformWhile, it, $completion) => i.p6c($this$transformWhile, it, $completion);
  l.$arity = 2;
  return l;
}
var WebSocketNetworkTransport$execute$$inlined$map$1Class;
function WebSocketNetworkTransport$execute$$inlined$map$1() {
  if (WebSocketNetworkTransport$execute$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, $request, $deferredJsonMerger, this$0) {
        this.y6b_1 = $this;
        this.z6b_1 = $request;
        this.a6c_1 = $deferredJsonMerger;
        this.b6c_1 = this$0;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy_0.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$map$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$map$1Class;
}
var WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
function WebSocketNetworkTransport$execute$$inlined$filterNot$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filterNot$1Class === VOID) {
    class $ {
      constructor($this, $deferredJsonMerger) {
        this.e6c_1 = $this;
        this.f6c_1 = $deferredJsonMerger;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy_1.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filterNot$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
}
var WebSocketNetworkTransport$execute$slambdaClass_1;
function WebSocketNetworkTransport$execute$slambda_3() {
  if (WebSocketNetworkTransport$execute$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $request) {
        this.g6c_1 = this$0;
        this.h6c_1 = $request;
      }
      q6c($this$onCompletion, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$onCompletion, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.q6c(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WebSocketNetworkTransport$execute$slambdaClass_1 = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass_1;
}
function WebSocketNetworkTransport$execute$slambda_4(this$0, $request) {
  var i = new (WebSocketNetworkTransport$execute$slambda_3())(this$0, $request);
  var l = ($this$onCompletion, it, $completion) => i.q6c($this$onCompletion, it, $completion);
  l.$arity = 2;
  return l;
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(serverUrl, headers, webSocketEngine, idleTimeoutMillis, protocolFactory, reopenWhen) {
        webSocketEngine = webSocketEngine === VOID ? new (DefaultWebSocketEngine())() : webSocketEngine;
        idleTimeoutMillis = idleTimeoutMillis === VOID ? 60000n : idleTimeoutMillis;
        protocolFactory = protocolFactory === VOID ? new (Factory())() : protocolFactory;
        this.o6a_1 = serverUrl;
        this.p6a_1 = headers;
        this.q6a_1 = webSocketEngine;
        this.r6a_1 = idleTimeoutMillis;
        this.s6a_1 = protocolFactory;
        this.t6a_1 = reopenWhen;
        this.u6a_1 = Channel(2147483647);
        this.v6a_1 = MutableSharedFlow(0, 2147483647, BufferOverflow_SUSPEND_getInstance());
        this.w6a_1 = asSharedFlow(this.v6a_1);
        this.x6a_1 = this.v6a_1.g1f();
        this.y6a_1 = Dispatchers_getInstance().j13_1.a13(1);
        this.z6a_1 = CoroutineScope_0(this.y6a_1);
        launch(this.z6a_1, VOID, VOID, WebSocketNetworkTransport$slambda_0(this));
        var tmp = this;
        tmp.a6b_1 = new (WebSocketNetworkTransport$listener$1())(this);
      }
      j65(request) {
        var deferredJsonMerger = new (DeferredJsonMerger())();
        // Inline function 'kotlinx.coroutines.flow.filter' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_0 = onSubscription(this.w6a_1, WebSocketNetworkTransport$execute$slambda_0(this, request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp = new (WebSocketNetworkTransport$execute$$inlined$filter$1())(this_0, request);
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_1 = transformWhile(tmp, WebSocketNetworkTransport$execute$slambda_2(request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        // Inline function 'kotlinx.coroutines.flow.filterNot' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_2 = new (WebSocketNetworkTransport$execute$$inlined$map$1())(this_1, request, deferredJsonMerger, this);
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp_0 = new (WebSocketNetworkTransport$execute$$inlined$filterNot$1())(this_2, deferredJsonMerger);
        return onCompletion(tmp_0, WebSocketNetworkTransport$execute$slambda_4(this, request));
      }
      vz() {
        this.u6a_1.f1b(Dispose_instance);
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport', VOID, VOID, VOID, [1]);
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
//region block: exports
export {
  Builder_0 as Builder3moivcm5iuump,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
